import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NewsComponent} from './news/news.component';
import {TranslateModule} from '../../shared/pipes/translate/translate.module';
import {NewsContentComponent} from './news/news-content/news-content.component';

@NgModule({
  declarations: [NewsComponent, NewsContentComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [NewsComponent]
})
export class NewsModule {
}
